// extracted by mini-css-extract-plugin
export default {"overText":"OverText_overText__9ouk9","text":"OverText_text__SBX7i"};